export default "__VITE_ASSET__Dd$cmc2z__"